import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { faArchive, faFireFlameCurved, faHouseChimney, faToolbox, faUserClock } from '@fortawesome/pro-duotone-svg-icons'

export type Item =
  | { label: string, header: true }
  | { label: string, icon: IconProp, url: string }
  | { blank: true }

export const isHeader = (item: Item): item is { label: string, header: true } => (item as { header: boolean }).header
export const isBlank = (item: Item): item is { blank: true } => (item as { blank: boolean }).blank
export const isLink = (item: Item): item is { label: string, icon: IconProp, url: string } =>
  !isHeader(item) && !isBlank(item)

export const COLUMN_COUNT = 3

// The modal is a row-major grid, so a column that loses an entry has to be padded rather
// than closed up, or every later item shifts into the wrong column.
export const buildAddNewItems = (showServiceTickets: boolean): Item[] => {
  const work: Item[] = [
    { label: 'Project Estimate', url: 'projects#new', icon: faArchive },
    ...(showServiceTickets
      ? [{ label: 'Service Ticket Estimate', url: 'tickets#new', icon: faFireFlameCurved } as Item]
      : []),
    { label: 'Maintenance Contract Estimate', url: 'maintenance#new', icon: faToolbox },
  ]
  const contactAndInfo: Item[] = [
    { label: 'Lead', url: 'customers#newLead', icon: faHouseChimney },
    { label: 'Customer', url: 'customers#newCustomer', icon: faHouseChimney },
    { label: 'Property', url: 'customers#newProperty', icon: faHouseChimney },
  ]
  const other: Item[] = [
    { label: 'Consultation', url: 'customers#newConsultation', icon: faUserClock },
  ]

  const columns = [work, contactAndInfo, other]
  const rowCount = Math.max(...columns.map((column) => column.length))
  const items: Item[] = [
    { label: 'Work', header: true },
    { label: 'Contact & Info', header: true },
    { label: 'Other', header: true },
  ]
  for (let row = 0; row < rowCount; row++) {
    for (const column of columns) {
      items.push(column[row] ?? { blank: true })
    }
  }
  return items
}
